export const identity = {
    'image/png': ['.png'],
    'image/jpeg': ['.jpeg', '.jpg'],
    'application/pdf': ['.pdf'],
};

export const identityWithExcel = {
    ...identity,
    'application/vnd.ms-excel': ['.xls', '.xlsx']
};
